export default __webpack_public_path__ + "static/media/SM3.bd1a6a3b.jpg";